import React from 'react';
import cn from 'classnames';

import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    borderRadius: 10,
    boxShadow: '-10px 11.1px 50px 0 rgba(188, 198, 210, 0.33)',
    width: '100%',
    paddingLeft: 35,
    paddingRight: 42,
    paddingTop: 45.8,
    paddingBottom: 66.4,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
  },
});

const PaperWrapper = ({ classes, children, className }) => (
  <Paper className={cn(classes.root, { [className]: !!className })}>
    {children}
  </Paper>
);

export default withStyles(styles)(PaperWrapper);
